import { render, staticRenderFns } from "./FormOstolasku.vue?vue&type=template&id=c4442eb6&scoped=true&"
import script from "./FormOstolasku.vue?vue&type=script&lang=js&"
export * from "./FormOstolasku.vue?vue&type=script&lang=js&"
import style0 from "./FormOstolasku.vue?vue&type=style&index=0&id=c4442eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4442eb6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCard,VCol,VDatePicker,VForm,VHover,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4442eb6')) {
      api.createRecord('c4442eb6', component.options)
    } else {
      api.reload('c4442eb6', component.options)
    }
    module.hot.accept("./FormOstolasku.vue?vue&type=template&id=c4442eb6&scoped=true&", function () {
      api.rerender('c4442eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormOstolasku.vue"
export default component.exports